import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
} from '@angular/core';
import { PercentToValuePipe } from '@marmon/frontend/common';
import {
	CellColorCode,
	ColorCodeCellBase,
} from './color-code-cell-base.component';

@Component({
	standalone: true,
	providers: [PercentToValuePipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'mar-color-code-cell',
	templateUrl: 'color-code-cell.component.html',
	host: { class: 'flex gap-2 items-center' },
})
export class ColorCodeCellComponent extends ColorCodeCellBase<string> {
	readonly color = input.required<CellColorCode>();

	override readonly formattedValue = computed(() => this.value());

	override getColorCode(): CellColorCode {
		return this.color();
	}
}
